module.exports = __webpack_public_path__ + "img/compact.675e88dd.jpg";